(() => {
  const start = () => document.querySelectorAll('[data-astra-request]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form'), messages = JSON.parse(root.querySelector('[data-request-messages]').textContent);
    const key = 'astra:request-draft:v2:' + location.pathname, ttl = 30 * 60 * 1000;
    const success = root.querySelector('[data-request-success]');
    const removeDraft = () => { try { sessionStorage.removeItem(key); } catch {} };
    if (success) { removeDraft(); success.focus(); return; }
    const fields = [...root.querySelectorAll('[data-field]')];
    const button = root.querySelector('[data-request-submit]');
    const status = root.querySelector('[data-request-status]'), retry = root.querySelector('[data-request-retry]');
    const originalLabel = button.textContent, enabled = root.dataset.enabled === 'true';
    let busy = false, pending = false, expiresTimer;
    const fieldIds = [...new Set(fields.map(field => field.dataset.field))];
    const group = id => fields.filter(field => field.dataset.field === id);
    const valueOf = id => {
      const items = group(id);
      if (!items.length) return '';
      if (items[0].type === 'radio') {
        const checked = items.find(item => item.checked);
        return checked ? checked.value.trim() : '';
      }
      return items[0].value.trim();
    };
    const announce = (text, focus = false) => { status.textContent = text; status.hidden = false; if (focus) status.focus(); };
    const draft = () => ({time: Date.now(), pending, values: Object.fromEntries(fieldIds.map(id => [id, valueOf(id)]))});
    const save = () => {
      try { sessionStorage.setItem(key, JSON.stringify(draft())); clearTimeout(expiresTimer); expiresTimer = setTimeout(removeDraft, ttl); }
      catch { announce(messages.storage_error); }
    };
    const unlock = () => { busy = false; pending = false; button.disabled = false; button.textContent = originalLabel; form.removeAttribute('aria-busy'); };
    const mark = (id, error) => {
      const output = root.querySelector('[data-error="' + id + '"]');
      if (output) { output.textContent = error; output.hidden = !error; }
      group(id).forEach(field => {
        if (error) field.setAttribute('aria-invalid', 'true');
        else field.removeAttribute('aria-invalid');
      });
      return !error;
    };
    const validateField = id => {
      const items = group(id);
      const value = valueOf(id);
      let error = '';
      if (['name', 'body'].includes(id) && !value) error = messages['error_' + id];
      if (id === 'email' && (!value || (items[0] && items[0].validity.typeMismatch))) error = messages.error_email;
      if (id === 'phone' && value.replace(/\D/g, '').length < 6) error = messages.error_phone;
      if (id === 'material' && !value) error = messages.error_material;
      if (id === 'quantity' && value && (!/^\d+$/.test(value) || !Number.isSafeInteger(Number(value)) || Number(value) < 1)) error = messages.error_quantity;
      if (id === 'date' && value && items[0] && items[0].validity && items[0].validity.badInput) error = messages.error_date;
      return mark(id, error);
    };
    form.noValidate = true;
    root.querySelector('[data-request-fields]').disabled = false;
    button.disabled = false;
    try {
      const stored = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (stored && Date.now() - stored.time < ttl && stored.values) {
        fieldIds.forEach(id => {
          const items = group(id);
          const saved = stored.values[id];
          if (typeof saved !== 'string') return;
          if (items[0] && items[0].type === 'radio') items.forEach(item => { item.checked = item.value === saved; });
          else if (items[0]) items[0].value = saved;
        });
        if (stored.pending && enabled) { announce(messages.uncertain); retry.hidden = false; button.disabled = true; busy = true; pending = true; }
        expiresTimer = setTimeout(removeDraft, Math.max(0, ttl - (Date.now() - stored.time)));
      } else removeDraft();
    } catch { removeDraft(); }
    if (root.querySelector('[data-server-errors]')) { unlock(); retry.hidden = true; save(); root.querySelector('[data-server-errors]').focus(); }
    fields.forEach(field => field.addEventListener('input', () => { if (field.hasAttribute('aria-invalid')) validateField(field.dataset.field); save(); }));
    fields.forEach(field => field.addEventListener('change', () => { if (field.hasAttribute('aria-invalid') || field.type === 'radio') validateField(field.dataset.field); save(); }));
    const drop = root.querySelector('[data-request-drop]');
    const fileInput = root.querySelector('[data-field-file]');
    const fileName = root.querySelector('[data-request-file-name]');
    const reference = root.querySelector('[data-field="reference"]');
    const applyFile = file => {
      if (!file || !reference) return;
      reference.value = file.name;
      if (fileName) fileName.textContent = file.name;
      save();
    };
    if (fileInput) fileInput.addEventListener('change', () => applyFile(fileInput.files[0]));
    if (drop) {
      ['dragenter', 'dragover'].forEach(type => drop.addEventListener(type, event => { event.preventDefault(); drop.classList.add('is-over'); }));
      ['dragleave', 'drop'].forEach(type => drop.addEventListener(type, event => { event.preventDefault(); drop.classList.remove('is-over'); }));
      drop.addEventListener('drop', event => {
        const file = event.dataTransfer && event.dataTransfer.files[0];
        if (!file || !fileInput) return;
        const transfer = new DataTransfer();
        transfer.items.add(file);
        fileInput.files = transfer.files;
        applyFile(file);
      });
    }
    retry.addEventListener('click', () => { unlock(); retry.hidden = true; status.hidden = true; save(); button.focus(); });
    form.addEventListener('submit', event => {
      if (busy) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      const errors = fieldIds.filter(id => !validateField(id));
      if (errors.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        announce(messages.error_summary);
        const first = group(errors[0])[0];
        if (first) first.focus();
        save();
        return;
      }
      if (!enabled) { event.preventDefault(); event.stopImmediatePropagation(); announce(messages.checked, true); save(); return; }
      if (navigator.onLine === false) { event.preventDefault(); event.stopImmediatePropagation(); announce(messages.network_error, true); save(); return; }
      pending = true;
      save();
      queueMicrotask(() => {
        if (event.defaultPrevented) return;
        busy = true;
        button.disabled = true;
        button.textContent = messages.sending;
        form.setAttribute('aria-busy', 'true');
        announce(messages.sending);
        setTimeout(() => { if (busy && pending) { form.removeAttribute('aria-busy'); button.textContent = originalLabel; announce(messages.uncertain, true); retry.hidden = false; } }, 45000);
      });
    }, true);
    window.addEventListener('pageshow', event => {
      if (event.persisted && pending) { busy = true; button.disabled = true; button.textContent = originalLabel; form.removeAttribute('aria-busy'); retry.hidden = false; announce(messages.uncertain); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
